import styled from 'styled-components';

const StyledCameraSettingsSection = styled.div`
	position: relative;
	width: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	padding: 20px;

	&:first-child {
		padding-right: 10px;
	}

	&:last-child {
		padding-left: 10px;
	}
`;

const StyledCameraSettingsSubSection = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
`;

export { StyledCameraSettingsSection, StyledCameraSettingsSubSection };
